export default __webpack_public_path__ + "static/media/seo.2cc7e4d9.svg";